module.exports = __webpack_public_path__ + "img/DasLetzteBand.31488fa0.jpg";